import script from "./SharedExpandableContent.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedExpandableContent.vue?vue&type=script&setup=true&lang=js"

import "./SharedExpandableContent.vue?vue&type=style&index=0&id=e2ed48bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2ed48bc"]])

export default __exports__